import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import z from 'zod';
import { publicHttpClient } from '../httpClient';
import { createApiResponseSchema, createPagingApiResponseSchema } from '../utils';
import { couponsApiPath } from './apiPath';

const GetCouponsRequestSchema = z
  .object({
    shopTitle: z.string(),
    page: z.number().int().positive().optional(),
    size: z.number().int().positive().optional(),
  })
  .describe('GetCouponsRequest');

export type GetCouponsRequest = z.infer<typeof GetCouponsRequestSchema>;

export const CuratorCouponSchema = z
  .object({
    couponNo: z.number().int(),
    couponName: z.string(),
    salesRate: z.number(),
    useStartDate: z.string(),
    useEndDate: z.string(),
    status: z.enum(['AVAILABLE', 'RECEIVED', 'EXHAUSTED', 'EXPIRED']),
    brandId: z.string(),
  })
  .describe('CuratorCoupon');

export type CuratorCoupon = z.infer<typeof CuratorCouponSchema>;

const GetCouponsDataSchema = createPagingApiResponseSchema(CuratorCouponSchema);
export const GetCouponsResponseSchema = createApiResponseSchema(GetCouponsDataSchema);
export type GetCouponsResponse = z.infer<typeof GetCouponsResponseSchema>;

export const fetchCoupons = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetCouponsRequestSchema),
    async ({ shopTitle, page, size }: GetCouponsRequest): Promise<GetCouponsResponse> =>
      executeStandardRequest(() =>
        publicHttpClient.get<GetCouponsResponse>(couponsApiPath.getCoupons, {
          shopTitle,
          page,
          size,
        }),
      ),
    validateApiResponse(GetCouponsResponseSchema),
  ),
);
